<div
  class="drag-box"
  appFreeDragging
  [boundaryQuery]="boundaryQuery"
  [xOffSet]="xOffSet"
  [yOffSet]="yOffSet"
  [ngStyle]="{
    'width': maxWidth,
    'max-width': maxWidth,
    'max-height': maxHeight,
    'border-radius': borderRadius,
    background,
    padding,
    border,
  }">
  <div class="drag-box-container" >
    <div *ngIf="dragIconPosition === 'top' || dragIconPosition === 'y-axis'" class="drag-box-container-handler-top" appFreeDraggingHandle>
      <img [src]="'../../../../../../assets/images/'+dragIcon" />
    </div>
    <div class="drag-box-container-handler-row">
      <div *ngIf="dragIconPosition === 'left' || dragIconPosition === 'x-axis'" class="drag-box-container-handler-left" appFreeDraggingHandle>
        <img [src]="'../../../../../../assets/images/'+dragIcon" />
      </div>
      <div>
        <ng-content select="[iptv-drag__content]"></ng-content>
      </div>
      <div *ngIf="dragIconPosition === 'rigth' || dragIconPosition === 'x-axis'" class="drag-box-container-handler-rigth" appFreeDraggingHandle>
        <img [src]="'../../../../../../assets/images/'+dragIcon" />
      </div>
    </div>
    <div *ngIf="dragIconPosition === 'bottom' || dragIconPosition === 'y-axis'" class="drag-box-container-handler-bottom" appFreeDraggingHandle>
      <img [src]="'../../../../../../assets/images/'+dragIcon" />
    </div>
  </div>
</div>
